import { ITeamCalendarResults } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const TeamCalendarResultsWrapper = React.lazy(() => import('./team-calendar-results'));
export interface IDynamicTeamCalendarResults extends IComponentModel<ITeamCalendarResults> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicTeamCalendarResults = ({
  /* istanbul ignore next: default value */ model = {} as ITeamCalendarResults,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicTeamCalendarResults) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <TeamCalendarResultsWrapper
      live={live}
      initialModel={validateModel(model) as ITeamCalendarResults}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicTeamCalendarResults;
